import { Button, Icon, TextField, Box } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

export default function LGCrudToolbar(props) {
  const { handlePost, customButtons, searchValue, onSearchChange, search, searchPlaceholder } = props;
  return (
    <GridToolbarContainer>
      {handlePost && (
        <Button
          color="primary"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handlePost}
        >
          Agregar
        </Button>
      )}
      {search && onSearchChange && (
        <Box sx={{ ml: 2, flexGrow: 1, maxWidth: 400 }}>
          <TextField
            fullWidth
            size="small"
            placeholder={searchPlaceholder || "Buscar por código o descripción..."}
            value={searchValue || ""}
            onChange={(e) => onSearchChange(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon sx={{ mr: 1, color: "action.active" }} />,
            }}
            sx={{ backgroundColor: "background.paper" }}
          />
        </Box>
      )}
      {customButtons?.map((button, index) => (
        <Button
          key={index}
          color={button.color || "primary"}
          variant="contained"
          startIcon={button.icon && <Icon>{button.icon}</Icon>}
          onClick={button.onClick}
          sx={{ ml: 1 }}
        >
          {button.label}
        </Button>
      ))}
    </GridToolbarContainer>
  );
}
